<template>
    <div v-if="messageInfo === 'loading'" class="small-12 align-center clover-animation">    
        <!-- <img :src="`${publicPath}images/logo-clover.gif`" alt="loading" /> -->
        <span>Chargement</span>
    </div>
    <div v-else class="small-4 align-center message">
        {{messageInfo}}
    </div>
</template>

<script>
export default {
    name: "AlertMessage",    
    props: {
        messageInfo: String,
    },
    data () {
        return {
            publicPath: process.env.BASE_URL
        }
    }
}
</script>

<style>
 .message {
    margin: 0 auto;
    background: gray;
    color: white;
    padding: 20px;
    border-radius: 10px;
    font-weight: 700;
 }
</style>